<template>
    <div id="item-ledger-entry-filter">
        <b-row>

            <b-col>
                <b-input-group size="sm" style="width: 100%;" v-if="!isNotMobileDevice || isNotOrderPage">
                    <v-select style="width: 100%;" class="success select-size-sm"
                        :class="searchType == 'MEDICAMENTS' ? 'searchTypeSuccess' : 'searchTypePrimary'"
                        :options="paginated" :filterable="false" @open="onOpen" @close="onClose" label="Description"
                        @search="handleSearch" v-model="selected" ref="select">
                        <template #option="{ description }">

                            <div>
                                <span class="description" v-html="highlightSearchText(description)"></span>
                            </div>
                        </template>

                        <span slot="no-options">

                            <span v-if="search.trim() != ''">

                                <div class="d-flex justify-content-center" v-if="allProducts.length == 0">
                                    <b-button variant="primary" disabled class="mr-1" size="sm">
                                        <b-spinner small type="grow" />
                                        chargement en cours
                                        <b-spinner small type="grow" />
                                    </b-button>
                                </div>

                                <div class="d-flex align-items-center" v-else>
                                    Désolé, aucun article trouvé
                                </div>

                            </span>
                            <span v-else>
                                <div class="d-flex justify-content-center" v-if="allProducts.length == 0">
                                    <b-button variant="primary" disabled class="mr-1" size="sm">
                                        <b-spinner small type="grow" />
                                        chargement en cours
                                        <b-spinner small type="grow" />
                                    </b-button>
                                </div>
                            </span>
                        </span>

                        <template #list-footer>
                            <li v-show="hasNextPage && search.trim() != ''" ref="load" class="loader">
                                Chargement plus d'articles...
                            </li>
                        </template>
                    </v-select>
                </b-input-group>

                <b-input-group size="sm" style="width: 100%;" v-else>
                    <v-select style="width: 90%;" class="success select-size-sm"
                        :class="searchType == 'MEDICAMENTS' ? 'searchTypeSuccess' : 'searchTypePrimary'"
                        :options="paginated" :filterable="false" @open="onOpen" @close="onClose" label="Description"
                        @search="handleSearch" v-model="selected" ref="select">
                        <template #option="{ description, inventory }">
                            <!-- <div class="d-flex align-items-center">
                            <b-badge pill variant="success" v-if="Family == 'MEDICAMENT'" class="mr-50">
                                <span>{{ Family }}</span>
                            </b-badge>
                            <b-badge pill variant="primary" v-else-if="Family == 'PARA'" class="mr-50">
                                <span>{{ Family }}</span>
                            </b-badge>
                            <b-badge pill variant="warning" v-else-if="Family == 'ACCESSOIRE'" class="mr-50">
                                <span>{{ Family }}</span>
                            </b-badge>
                            <b-badge pill variant="secondary" class="mr-50" v-else>
                                <span>{{ Family }}</span>
                            </b-badge>
                            <span class="ml-auto" v-html="highlightSearchText(Description)"></span>
                            <div>
                                <a href="#" @click="viewSubstitutions(Description)">Substitutions</a>
                                <a href="#" @click="viewComplementaires(Description)">Complémentaires</a>
                            </div>
                        </div> -->

                            <div>
                                <span class="description" v-html="highlightSearchText(description)"></span>
                                <span class="links" v-if="search.trim().length >= 4" :key="itemKey">
                                    <!-- <b-link href="#" class="font-weight-bold mr-1"
                                        style="border-bottom: 1px solid #6e6b7b; color: inherit;"
                                        @click.stop="viewSubstitutions(Description)">Substitutions</b-link>

                                    <b-link href="#" class="font-weight-bold"
                                        style="border-bottom: 1px solid #6e6b7b; color: inherit;"
                                        @click.stop="viewComplementaires(Description)">Complémentaires</b-link> -->
                                    <div>

                                        <!-- <b-button variant="secondary" disabled size="sm" v-if="inventory == undefined">
                                            <b-spinner small type="grow" />
                                        </b-button> -->
                                        <b-badge variant="secondary" v-if="inventory == undefined">
                                            <b-spinner small type="grow" />
                                        </b-badge>
                                        <b-badge variant="success" v-else-if="inventory">
                                            <feather-icon icon="CheckIcon" />
                                        </b-badge>
                                        <b-badge variant="danger" v-else>
                                            <feather-icon icon="XIcon" />
                                        </b-badge>

                                    </div>

                                </span>
                            </div>
                        </template>

                        <span slot="no-options">

                            <span v-if="search.trim() != ''">
                                <div class="d-flex justify-content-center" v-if="allProducts.length == 0">
                                    <b-button variant="primary" disabled class="mr-1" size="sm">
                                        <b-spinner small type="grow" />
                                        chargement en cours
                                        <b-spinner small type="grow" />
                                    </b-button>
                                </div>

                                <div class="d-flex align-items-center" v-else>
                                    Désolé, aucun article trouvé
                                </div>

                            </span>
                            <span v-else>
                                <div class="d-flex justify-content-center" v-if="allProducts.length == 0">
                                    <b-button variant="primary" disabled class="mr-1" size="sm">
                                        <b-spinner small type="grow" />
                                        chargement en cours
                                        <b-spinner small type="grow" />
                                    </b-button>
                                </div>
                                <!-- <div v-else>Effectuer une recherche d'articles en se basant sur leur désignation.</div> -->
                            </span>
                        </span>

                        <template #list-footer>
                            <li v-show="hasNextPage && search.trim() != ''" ref="load" class="loader">
                                Chargement plus d'articles...
                            </li>
                        </template>
                    </v-select>
                    <b-input-group-append style="width: 10%;">
                        <b-dropdown text="Articles"
                            :variant="searchType == 'MEDICAMENTS' ? 'relief-success' : 'relief-primary'" right
                            size="sm">
                            <b-dropdown-item @click="$emit('distributionClick')" variant="primary">
                                <feather-icon icon="GridIcon" /> Répartition
                            </b-dropdown-item>
                            <b-dropdown-divider />
                            <b-dropdown-item @click="$emit('arrivalClick')" variant="warning">
                                <feather-icon icon="TruckIcon" /> Arrivage
                            </b-dropdown-item>
                            <b-dropdown-divider />
                            <b-dropdown-item @click="$emit('noveltyClick')" variant="info">
                                <feather-icon icon="FilePlusIcon" /> Nouveauté
                            </b-dropdown-item>
                            <b-dropdown-divider />
                            <b-dropdown-item @click="$emit('promotionClick')" variant="success">
                                <feather-icon icon="GiftIcon" /> Promotion
                            </b-dropdown-item>
                            <b-dropdown-divider />
                            <b-dropdown-item @click="$emit('itemsClick')" variant="secondary">
                                <feather-icon icon="SearchIcon" /> Tous
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-input-group-append>
                </b-input-group>
            </b-col>

        </b-row>
    </div>
</template>
<script>

import vSelect from 'vue-select'

export default {
    props: {
        searchType: {
            type: String,
            required: true
        },
        isNotOrderPage: {
            type: Boolean,
            required: false
        }
    },
    components: {
        vSelect
    },
    data() {
        return {
            itemKey: 0,
            isLoading: false,
            selected: null,
            observer: null,
            limit: 10,
            search: '',
        }
    },
    computed: {
        isNotMobileDevice() {
            return !/Mobi/i.test(navigator.userAgent)
        },
        filtered() {
            if (this.searchType == "TOUS")
                return this.$store.getters["app-items/geItems"].filter(item => item.description.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
                    .sort((a, b) => {
                        const indexA = a.description.toLowerCase().indexOf(this.search.toLowerCase());
                        const indexB = b.description.toLowerCase().indexOf(this.search.toLowerCase());
                        if (indexA === indexB) {
                            return 0;
                        }
                        return indexA < indexB ? -1 : 1;
                    });
            else if (this.searchType == "MEDICAMENTS")
                return this.$store.getters["app-items/geItemsMED"].filter(item => item.description.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
                    .sort((a, b) => {
                        const indexA = a.description.toLowerCase().indexOf(this.search.toLowerCase());
                        const indexB = b.description.toLowerCase().indexOf(this.search.toLowerCase());
                        if (indexA === indexB) {
                            return 0;
                        }
                        return indexA < indexB ? -1 : 1;
                    });
            else return this.$store.getters["app-items/geItemsPARA"].filter(item => item.description.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
                .sort((a, b) => {
                    const indexA = a.description.toLowerCase().indexOf(this.search.toLowerCase());
                    const indexB = b.description.toLowerCase().indexOf(this.search.toLowerCase());
                    if (indexA === indexB) {
                        return 0;
                    }
                    return indexA < indexB ? -1 : 1;
                });
        },
        allProducts() {
            if (this.searchType == "TOUS")
                return this.$store.getters["app-items/geItems"];
            else if (this.searchType == "MEDICAMENTS")
                return this.$store.getters["app-items/geItemsMED"];
            else
                return this.$store.getters["app-items/geItemsPARA"]
        },
        paginated() {
            if (this.search.trim() == "")
                return [];
            return this.filtered.slice(0, this.limit)
        },
        hasNextPage() {
            return this.paginated.length < this.filtered.length
        },
    },
    mounted() {
        this.observer = new IntersectionObserver(this.infiniteScroll)
    },
    watch: {
        selected(val) {
            if (val) {
                this.$emit("productClicked", val);
                this.search = "";
                this.selected = null;
            }
        }
    },
    created() {
        this.$nextTick(() => {
            this.$refs["select"].$el.querySelector("input").focus();
        });
    },
    methods: {
        async handleSearch(query) {
            this.search = query;
            if (query.trim().length >= 4) {
                await this.fetchInventoryData();
                this.itemKey += 1;
            }
        },
        // async fetchInventoryData() {
        //     try {
        //         this.paginated.forEach(async (element) => {
        //             this.$http.get("_item/itemCompanyInfoCatalog/" + element.code).then(response => {
        //                 console.log(response);
        //                 if (response.data.status == 200) {
        //                     // Use Vue.set to update the property and trigger reactivity
        //                     // this.$set(this.paginated, index, {
        //                     //     ...element,
        //                     //     inventory: response.data.result.inventory,
        //                     //     key: element.key + 1,
        //                     // });
        //                     element.inventory = response.data.result.inventory;
        //                 } else {
        //                     // Use Vue.set to update the property and trigger reactivity
        //                     // this.$set(this.paginated, index, {
        //                     //     ...element,
        //                     //     inventory: -1,
        //                     //     key: element.key + 1,
        //                     // });
        //                     element.inventory = -1;
        //                 }
        //             });
        //         });
        //     } catch (error) {
        //         console.error('Error fetching inventory data:', error);
        //     }
        // },
        // async fetchInventoryData() {
        //     try {
        //         await Promise.all(this.paginated.map(async (element) => {
        //             const response = await this.$http.get("_item/itemCompanyInfoCatalog/" + element.code);
        //             console.log(response);
        //             if (response.data.status == 200) {
        //                 // Update the property directly, no need for Vue.set
        //                 element.inventory = response.data.result.inventory;
        //             } else {
        //                 // Update the property directly, no need for Vue.set
        //                 element.inventory = -1;
        //             }
        //         }));
        //     } catch (error) {
        //         console.error('Error fetching inventory data:', error);
        //     }
        // },
        async fetchInventoryData() {
            try {
                for (const element of this.paginated) {
                    const response = await this.$http.get("_item/itemCompanyInfoCatalog/" + element.code);
                    console.log(response)
                    if (response.data.status == 200) {
                        // Update the property directly, no need for Vue.set
                        element.inventory = response.data.result.inventory;
                    } else {
                        // Update the property directly, no need for Vue.set
                        element.inventory = false;
                    }
                    // Force the view to update after each response
                    this.$forceUpdate();
                }
            } catch (error) {
                console.error('Error fetching inventory data:', error);
            }
        },

        viewSubstitutions(description) {
            console.log(description);
        },
        highlightSearchText(text) {
            const regex = new RegExp(this.search, 'gi');
            return text.replace(regex, match => `<b>${match}</b>`);
        },
        async onOpen() {
            if (this.hasNextPage) {
                await this.$nextTick()
                this.observer.observe(this.$refs.load)
            }
        },
        onClose() {
            this.observer.disconnect();
            this.limit = 10;
        },
        async infiniteScroll([{ isIntersecting, target }]) {
            if (isIntersecting) {
                const ul = target.offsetParent
                const scrollTop = target.offsetParent.scrollTop
                this.limit += this.limit
                await this.$nextTick()
                ul.scrollTop = scrollTop
            }
        },
    },
}
</script>
<style lang="scss">
.loader {
    text-align: center;
    color: #bbbbbb;
}

.description {
    display: inline-block;
    width: 70%;
    /* Ajustez la largeur selon vos besoins */
}

.vs__dropdown-toggle {
    // border-radius: 0% !important;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
}

.searchTypeSuccess .vs__dropdown-toggle {
    border-color: #28c76f !important;
}

.searchTypePrimary .vs__dropdown-toggle {
    border-color: #7367f0 !important;
}

.links {
    display: inline-block;
    width: 30%;
    /* Ajustez la largeur selon vos besoins */
    text-align: right;
}
</style>